import Axios from 'axios'

const addressObjectToLabel = ({ prov, dist, subdist, zipcode }) => {
  // return `${prov} > ${dist} > ${subdist} > ${zipcode}`
  const isUsingBangkokAddressPrefix = (prov === 'กรุงเทพมหานคร')
  if (isUsingBangkokAddressPrefix) {
    return `แขวง${subdist}, เขต${dist}, ${prov}, ${zipcode}`
  }
  return `ตำบล${subdist}, อำเภอ${dist}, ${prov}, ${zipcode}`
}

const postcodeToFirstFoundAddress = async (postcode) => {
  try {
    const res = await Axios.post('/api/checkprice/auto-complete-address',{ query: postcode })
    if ('searched' in res.data) {
      const addressObject = res.data.searched[0]
      return addressObject
    }
    return false
  } catch (err) {
    return false
  }
}

export {
  addressObjectToLabel,
  postcodeToFirstFoundAddress,
}